import { combineReducers } from 'redux'
import { reducer as homeReducer } from '@/pages/Home/store'
import { reducer as newsReducer } from '@/pages/News/store'
import produce from 'immer'
import { StoreState } from './typings'

const defaultState: StoreState = {
  menuList: [
    {
      name: '公司',
      path: '/company',
      children: [
        {
          name: '公司簡介',
          path: '/company#banner',
        },
        {
          name: '發展歷程',
          path: '/company#timeline',
        },
        {
          name: '企業文化',
          path: '/company#culture',
        },
        {
          name: '歡樂大咖',
          path: '/company#mogul',
        },
      ],
    },
    {
      name: '遊戲產品',
      path: '/product',
      children: [
        {
          name: '龍之谷手游',
          path: 'https://dn.qq.com/index.shtml',
          target: '_blank',
        },
        {
          name: '英雄殺-小遊戲',
          path: '/product#product-card',
        },
        {
          name: '街機三國',
          path: 'http://sg.huanle.com/',
          target: '_blank',
        },
        {
          name: '美食大戰老鼠',
          path: 'http://my.4399.com/yxmsdzls/',
          target: '_blank',
        },
      ],
    },
    // {
    //   name: '人才招聘',
    //   target: '_blank',
    //   path: '/hire/socialRecruit',
    //   children: [
    //     {
    //       name: '社會招聘',
    //       target: '_blank',
    //       path: 'https://huanle.jobs.feishu.cn/society',
    //     },
    //     {
    //       name: '校園招聘',
    //       target: '_blank',
    //       path: 'https://huanle.jobs.feishu.cn/campus',
    //     },
    //   ],
    // },
    {
      name: '新聞動態',
      path: '/news',
      children: [
        {
          name: '企業動態',
          path: '/news#industry',
        },
        {
          name: '產品資訊',
          path: '/news#information',
        },
        {
          name: '歡樂活動',
          path: '/news#activities',
        },
      ],
    },
    // {
    //   name: '聯繫我們',
    //   path: '/contact',
    //   children: [],
    // },
  ],
}

const common = (state: StoreState = defaultState): StoreState =>
  produce(state, () => {})

const rootReducer = combineReducers({
  home: homeReducer,
  news: newsReducer,
  common,
})

export type AppState = ReturnType<typeof rootReducer>

export default rootReducer
